// Bootstrap's JS (and the Popper it needs for dropdowns) on demand.
//
// Nothing in the rebuild uses it: a grep for Bootstrap's whole JS API
// (.modal/.tooltip/.popover/.collapse/.carousel/.dropdown) across every view
// and script returns nothing, and its data-api markup survives in exactly
// one place -- the fixtravel layout's account dropdown. Two step1 partials
// also carry data-toggle="tab" but are rendered from nowhere.
//
// So rather than ship 75KB to every brand for one brand's dropdown, the
// caller checks for the markup and only then fetches this chunk.
let pending;

export function loadLegacyBootstrap() {
  if (!pending) {
    pending = import(/* webpackChunkName: "legacy-bootstrap" */ "./legacy_bootstrap_bundle");
  }
  return pending;
}
